import { isSafeRedirectUrl, generateRedirectUrl } from './redirectUtils';
import { Cookie } from './cookies';

export const goToLogout = () => {
  document.dispatchEvent(new CustomEvent('openConfirmLogoutNotification'));
  Cookie.remove('_utid');

  const redirectUrl = generateRedirectUrl('/logout');

  if (isSafeRedirectUrl(redirectUrl)) {
    window.location.href = redirectUrl;
  } else {
    console.warn("Попытка небезопасного редиректа была предотвращена.");
  }
};